import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/** @jsxRuntime automatic */
/** @jsxImportSource react */
import { Component, Suspense, lazy } from 'react';
import { PETS_BUNDLE_ENABLED } from './companionBuild.js';
import { ON_DEMAND_FILES, onDemand } from './onDemand.js';
// The public build substitutes this entire entry, including its state factory.
let loadedModule;
export const createActionReviewSession = async (owner, transport) => (await load()).createActionReviewSession(owner, transport);
export const createBuilderDraftSession = async (owner, transport) => (await load()).createBuilderDraftSession(owner, transport);
export const createCheckStatusSessions = async (owner, transport, onDisabled) => (await load()).createCheckStatusSessions(owner, transport, onDisabled);
// No session exists until the named module has loaded; cleanup must not start a
// new download after sign-out. Pending factories are cleared by their owner.
export const clearPetDecisionSession = (owner) => loadedModule?.clearPetDecisionSession(owner);
const load = onDemand({
    file: ON_DEMAND_FILES.companions,
    what: 'the companion interface',
    load: () => import('./companionBundle.js'),
    check: module => {
        const valid = ['PetsSidebar', 'PetsWorkspace', 'PetSignOutPreparation', 'PetPackageContent', 'PetAttentionItemCard',
            'createActionReviewSession', 'createCheckStatusSessions', 'createBuilderDraftSession', 'clearPetDecisionSession']
            .every(key => typeof module[key] === 'function');
        if (valid)
            loadedModule = module;
        return valid;
    },
    unavailable: 'This feature could not load. Reload Gyro to try again.',
});
class LoadBoundary extends Component {
    state = { failed: false };
    static getDerivedStateFromError() { return { failed: true }; }
    render() {
        return this.state.failed
            ? _jsx("p", { role: "alert", children: "This feature could not load. Reload Gyro to try again." })
            : this.props.children;
    }
}
function onDemandComponent(pick) {
    if (!PETS_BUNDLE_ENABLED)
        return (_props) => _jsx(_Fragment, {});
    const Loaded = lazy(async () => ({ default: pick(await load()) }));
    return (props) => {
        if (!PETS_BUNDLE_ENABLED)
            return _jsx(_Fragment, {});
        return _jsx(LoadBoundary, { children: _jsx(Suspense, { fallback: _jsx("span", { className: "gyro-companion-loading", role: "status", children: "Loading\u2026" }), children: _jsx(Loaded, { ...props }) }) });
    };
}
export const PetsSidebar = onDemandComponent(module => module.PetsSidebar);
export const PetsWorkspace = onDemandComponent(module => module.PetsWorkspace);
export const PetSignOutPreparation = onDemandComponent(module => module.PetSignOutPreparation);
export const PetPackageContent = onDemandComponent(module => module.PetPackageContent);
export const PetAttentionItemCard = onDemandComponent(module => module.PetAttentionItemCard);
//# sourceMappingURL=companionParts.js.map